module.exports = __webpack_public_path__ + "static/media/loader.623fde5f.svg";